import React, { useState, type ComponentType } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { useLeftSidebarState } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/left-sidebar-controller/index.tsx';
import { IsFhsEnabledProviderNavx2731 } from '@atlassian/jira-navigation-apps-sidebar-nav4-fhs-rollout/src/ui/is-fhs-enabled-provider-navx-2731/index.tsx';
import { PageLayout, type PageLayoutProps } from '@atlassian/jira-navigation-system/src/index.tsx';

// Used when full height sidebar is enabled
const PageLayoutWithFHSChanges = ({ children, ...props }: PageLayoutProps) => {
	const { isCollapsed } = useLeftSidebarState();
	const [defaultSideNavCollapsed] = useState(isCollapsed);

	return (
		<IsFhsEnabledProviderNavx2731 value>
			<PageLayout
				{...props}
				defaultSideNavCollapsed={defaultSideNavCollapsed}
				isSideNavShortcutEnabled
			>
				{children}
			</PageLayout>
		</IsFhsEnabledProviderNavx2731>
	);
};

const PageLayoutWithoutFhsChanges = ({ children, ...props }: PageLayoutProps) => (
	<IsFhsEnabledProviderNavx2731 value={false}>
		<PageLayout {...props}>{children}</PageLayout>
	</IsFhsEnabledProviderNavx2731>
);

export const JiraPageLayoutNew: ComponentType<PageLayoutProps> = componentWithCondition(
	() => expVal('navx-full-height-sidebar-exp', 'isEnabled', false),
	PageLayoutWithFHSChanges,
	PageLayoutWithoutFhsChanges,
);

export const JiraPageLayoutOld: ComponentType<PageLayoutProps> = componentWithFG(
	'navx-full-height-sidebar',
	PageLayoutWithFHSChanges,
	PageLayout,
);

export const JiraPageLayout: ComponentType<PageLayoutProps> = componentWithFG(
	'navx-2731-convert-jira-fhs-rollout',
	JiraPageLayoutNew,
	JiraPageLayoutOld,
);
